// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    indexerGetAddressesAddress (params?: {}): Promise<implicitReturnType>;
    indexerGetAddressesAddressParentSubaccountNumberNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetAssetPositions (params?: {}): Promise<implicitReturnType>;
    indexerGetAssetPositionsParentSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetCandlesPerpetualMarketsMarket (params?: {}): Promise<implicitReturnType>;
    indexerGetComplianceScreenAddress (params?: {}): Promise<implicitReturnType>;
    indexerGetFills (params?: {}): Promise<implicitReturnType>;
    indexerGetFillsParentSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetFundingPayments (params?: {}): Promise<implicitReturnType>;
    indexerGetFundingPaymentsParentSubaccount (params?: {}): Promise<implicitReturnType>;
    indexerGetHeight (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalPnl (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalPnlParentSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalBlockTradingRewardsAddress (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalFundingMarket (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalTradingRewardAggregationsAddress (params?: {}): Promise<implicitReturnType>;
    indexerGetOrderbooksPerpetualMarketMarket (params?: {}): Promise<implicitReturnType>;
    indexerGetOrders (params?: {}): Promise<implicitReturnType>;
    indexerGetOrdersParentSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    indexerGetPerpetualMarkets (params?: {}): Promise<implicitReturnType>;
    indexerGetPerpetualPositions (params?: {}): Promise<implicitReturnType>;
    indexerGetPerpetualPositionsParentSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetScreen (params?: {}): Promise<implicitReturnType>;
    indexerGetSparklines (params?: {}): Promise<implicitReturnType>;
    indexerGetTime (params?: {}): Promise<implicitReturnType>;
    indexerGetTradesPerpetualMarketMarket (params?: {}): Promise<implicitReturnType>;
    indexerGetTransfers (params?: {}): Promise<implicitReturnType>;
    indexerGetTransfersBetween (params?: {}): Promise<implicitReturnType>;
    indexerGetTransfersParentSubaccountNumber (params?: {}): Promise<implicitReturnType>;
    indexerGetVaultV1MegavaultHistoricalPnl (params?: {}): Promise<implicitReturnType>;
    indexerGetVaultV1MegavaultPositions (params?: {}): Promise<implicitReturnType>;
    indexerGetVaultV1VaultsHistoricalPnl (params?: {}): Promise<implicitReturnType>;
    indexerGetPerpetualMarketSparklines (params?: {}): Promise<implicitReturnType>;
    indexerGetPerpetualMarketsTicker (params?: {}): Promise<implicitReturnType>;
    indexerGetPerpetualMarketsTickerOrderbook (params?: {}): Promise<implicitReturnType>;
    indexerGetTradesPerpetualMarketTicker (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalFundingTicker (params?: {}): Promise<implicitReturnType>;
    indexerGetCandlesTickerResolution (params?: {}): Promise<implicitReturnType>;
    indexerGetAddressesAddressSubaccounts (params?: {}): Promise<implicitReturnType>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumberAssetPositions (params?: {}): Promise<implicitReturnType>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumberPerpetualPositions (params?: {}): Promise<implicitReturnType>;
    indexerGetAddressesAddressSubaccountNumberSubaccountNumberOrders (params?: {}): Promise<implicitReturnType>;
    indexerGetFillsParentSubaccount (params?: {}): Promise<implicitReturnType>;
    indexerGetHistoricalPnlParentSubaccount (params?: {}): Promise<implicitReturnType>;
    nodeRpcGetAbciInfo (params?: {}): Promise<implicitReturnType>;
    nodeRpcGetBlock (params?: {}): Promise<implicitReturnType>;
    nodeRpcGetBroadcastTxAsync (params?: {}): Promise<implicitReturnType>;
    nodeRpcGetBroadcastTxSync (params?: {}): Promise<implicitReturnType>;
    nodeRpcGetTx (params?: {}): Promise<implicitReturnType>;
    nodeRestGetCosmosAuthV1beta1AccountInfoDydxAddress (params?: {}): Promise<implicitReturnType>;
    nodeRestPostCosmosTxV1beta1Encode (params?: {}): Promise<implicitReturnType>;
    nodeRestPostCosmosTxV1beta1Simulate (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
